var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.news.length
    ? _c("div", { staticClass: "news-slider" }, [
        _c("div", { staticClass: "section-lastNews" }, [
          _c("div", { staticClass: "section-lastNews__header" }, [
            _c("div", { staticClass: "title" }, [
              _c("i", { staticClass: "icon-latest-news" }),
              _c("div", { staticClass: "title__text" }, [
                _c("h2", [_vm._v(_vm._s(_vm.$t("front.news.slider.title")))]),
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("front.news.slider.description")))
                ])
              ])
            ]),
            _c(
              "div",
              { staticClass: "slider-nav" },
              [
                _c("router-link", { attrs: { to: _vm.seeAllLink } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("front.news.button.see_all")) +
                      "\n                    "
                  ),
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "7",
                        height: "12",
                        viewBox: "0 0 7 12",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: { d: "M1 11L6 6L1 1", stroke: "#926D20" }
                      })
                    ]
                  )
                ]),
                _c(
                  "v-btn",
                  {
                    staticClass: "prev",
                    attrs: { id: "button-prev-relacionados" },
                    on: { click: _vm.swiperPrev }
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "11",
                          height: "10",
                          viewBox: "0 0 11 10",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M6 1L2 5L6 9",
                            stroke: "white",
                            "stroke-width": "1.5"
                          }
                        }),
                        _c("path", {
                          attrs: {
                            d: "M2.5 5H10.5",
                            stroke: "white",
                            "stroke-width": "1.5"
                          }
                        })
                      ]
                    )
                  ]
                ),
                _c(
                  "v-btn",
                  {
                    staticClass: "next",
                    attrs: { id: "button-next-relacionados" },
                    on: { click: _vm.swiperNext }
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "11",
                          height: "10",
                          viewBox: "0 0 11 10",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M5 1L9 5L5 9",
                            stroke: "white",
                            "stroke-width": "1.5"
                          }
                        }),
                        _c("path", {
                          attrs: {
                            d: "M8.5 5H0.5",
                            stroke: "white",
                            "stroke-width": "1.5"
                          }
                        })
                      ]
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "section-lastNews__content" },
            [
              _vm.news.length
                ? _c(
                    "swiper",
                    {
                      ref: "slider",
                      staticClass: "section-lastNews__slider",
                      attrs: { options: _vm.settings }
                    },
                    _vm._l(_vm.news, function(item) {
                      return _c(
                        "swiper-slide",
                        { key: item.id, staticClass: "item load" },
                        [
                          _c("div", { staticClass: "item__box" }, [
                            _c(
                              "div",
                              { staticClass: "item__image" },
                              [
                                _c("router-link", {
                                  staticClass: "item__image-category",
                                  attrs: { to: item.categoryPageUrl },
                                  domProps: {
                                    textContent: _vm._s(item.categoryTitle)
                                  }
                                }),
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "link",
                                    attrs: { to: item.pageUrl }
                                  },
                                  [
                                    _c(
                                      "picture",
                                      [
                                        _vm._l(
                                          item[
                                            _vm.isDeviceMobile
                                              ? "mobileImage"
                                              : "desktopImage"
                                          ].sourcesTypes,
                                          function(sourceType, index) {
                                            return _c("source", {
                                              key: index,
                                              attrs: {
                                                "data-srcset":
                                                  item[
                                                    _vm.isDeviceMobile
                                                      ? "mobileImage"
                                                      : "desktopImage"
                                                  ][sourceType],
                                                type: "image/" + sourceType
                                              }
                                            })
                                          }
                                        ),
                                        _c("img", {
                                          attrs: {
                                            "data-src":
                                              item[
                                                _vm.isDeviceMobile
                                                  ? "mobileImage"
                                                  : "desktopImage"
                                              ].jpg,
                                            alt: item.title
                                          }
                                        })
                                      ],
                                      2
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c("div", { staticClass: "item__content" }, [
                              _c("h2", {
                                domProps: { textContent: _vm._s(item.title) }
                              }),
                              _c("p", {
                                domProps: {
                                  textContent: _vm._s(item.shortDescription)
                                }
                              })
                            ])
                          ])
                        ]
                      )
                    }),
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }